export const LOGO_URL = "https://s3.ca-central-1.amazonaws.com/logojoy/logos/175675389/noBgColor.png";
export const BEN_PHOTO_URL = "https://irp.cdn-website.com/81321c78/dms3rep/multi/opt/Headshot+1-6ee3e70d-698w.jpg";

export const IMAGES = {
  hero: "https://images.pexels.com/photos/39932417/pexels-photo-39932417.jpeg?auto=compress&cs=tinysrgb&w=2000",
  heroAlt: "https://images.pexels.com/photos/37592477/pexels-photo-37592477.jpeg?auto=compress&cs=tinysrgb&w=2000",
  firstTimeBuyer: "https://images.pexels.com/photos/33869022/pexels-photo-33869022.jpeg?auto=compress&cs=tinysrgb&w=1600",
  movingHome: "https://images.pexels.com/photos/29854371/pexels-photo-29854371.jpeg?auto=compress&cs=tinysrgb&w=1600",
  buyToLet: "https://images.pexels.com/photos/35729495/pexels-photo-35729495.jpeg?auto=compress&cs=tinysrgb&w=1600",
  protection: "https://images.pexels.com/photos/33252239/pexels-photo-33252239.jpeg?auto=compress&cs=tinysrgb&w=1600",
  wholeOfLife: "https://images.pexels.com/photos/29472827/pexels-photo-29472827.jpeg?auto=compress&cs=tinysrgb&w=1600",
  business: "https://images.pexels.com/photos/37643775/pexels-photo-37643775.jpeg?auto=compress&cs=tinysrgb&w=1600",
};

export const GALLERY = [
  "https://images.pexels.com/photos/39932417/pexels-photo-39932417.jpeg?auto=compress&cs=tinysrgb&w=1400",
  "https://images.pexels.com/photos/37592477/pexels-photo-37592477.jpeg?auto=compress&cs=tinysrgb&w=1400",
  "https://images.pexels.com/photos/35729495/pexels-photo-35729495.jpeg?auto=compress&cs=tinysrgb&w=1400",
  "https://images.pexels.com/photos/33869022/pexels-photo-33869022.jpeg?auto=compress&cs=tinysrgb&w=1400",
  "https://images.pexels.com/photos/33252239/pexels-photo-33252239.jpeg?auto=compress&cs=tinysrgb&w=1400",
  "https://images.pexels.com/photos/37643775/pexels-photo-37643775.jpeg?auto=compress&cs=tinysrgb&w=1400",
  "https://images.pexels.com/photos/29854371/pexels-photo-29854371.jpeg?auto=compress&cs=tinysrgb&w=1400",
  "https://images.pexels.com/photos/29472827/pexels-photo-29472827.jpeg?auto=compress&cs=tinysrgb&w=1400",
];

export const MARKET_RATES = [
  { term: "2 Year Fixed", rate: "4.96%", fee: "£999 bank fee" },
  { term: "2 Year Tracker", rate: "3.99%", fee: "£1,499 bank fee" },
  { term: "5 Year Fixed", rate: "4.91%", fee: "£1,499 bank fee" },
];
export const RATES_DATE = "Illustrative best-buy rates — not a mortgage offer or representative example. Your actual rate depends on your circumstances, deposit and the lender's assessment. Speak to us for a personalised comparison.";

export const FEATURED_QUOTES = [
  {
    quote:
      "Ben was incredible from start to finish. Home buying is hard — I had two failed purchases before succeeding — yet Ben was a positive, knowledgeable and calming presence throughout. He showed me I could get a bigger (but still affordable) mortgage than I'd realised.",
    name: "Tom Sowerby",
    detail: "East Sussex · Google review",
  },
  {
    quote:
      "Highly recommended. Best mortgage broker in Berkshire. Ben turned around the mortgage incredibly quickly and was always in great communication. Can't recommend high enough.",
    name: "David Glass",
    detail: "Windlesham · Google review",
  },
  {
    quote:
      "Ben is an exceptional mortgage advisor. Having worked with him more than once, his ability to deal with atypical finances makes him our go-to person for new, porting or renewing mortgages.",
    name: "Trishnah Murphy",
    detail: "Chertsey · Google review",
  },
];

export const CONTACT = {
  phone: "01344 578847",
  phoneHref: "tel:+441344578847",
  email: "ben@btkmortgages.co.uk",
  address: "Ashley House, 136/138 The Broadway, Tolworth, Surrey, KT6 7JD",
  socials: [
    { label: "LinkedIn", href: "https://www.linkedin.com/company/btk-mortgage-services-ltd/" },
    { label: "WhatsApp", href: "https://wa.me/+4401344578847" },
    { label: "Facebook", href: "https://www.facebook.com/profile.php?id=61558695784793" },
    { label: "Instagram", href: "https://www.instagram.com/btk_mortgage_services" },
  ],
};

export const ABOUT = {
  heading: "Meet the Director",
  name: "Ben Kill CeMAP",
  role: "Director",
  quote:
    "I founded BTK Mortgage Services on the basis of creating a boutique mortgage & insurance advisory firm. Personal service is at the forefront of my mission and my ultimate goal is to help my clients navigate the complex mortgage & insurance world whilst relieving as much stress from their shoulders. This is achieved by utilising my carefully nurtured relationships with contacts within banks, building societies and insurers. What I offer is much more than just finding the best deal and right mortgage/cover amount. Of course, those elements are key to my advice but I also draw on my wealth of experience within the property market to best advise my clients on many other areas within the process",
  intro:
    "We're delighted to provide our world-class mortgage & protection solutions Nationwide. Let us help you plan for tomorrow and guide you on your path to home ownership.",
};

export const BUSINESS_PROTECTION_INTRO =
  "Business protection is a type of insurance designed to safeguard your business against various risks that could potentially threaten its operations, finances, or key individuals within the organization. Overall, business protection insurance plays a vital role in helping businesses mitigate risks and safeguard their financial stability, making it an essential consideration for any business owner.";

export const SERVICES = [
  {
    slug: "first-time-buyer",
    title: "First-Time Buyer",
    tagline: "Deposits from 5%, agreements in principle in days, and a guide who answers every question.",
    image: IMAGES.firstTimeBuyer,
    description:
      "Buying your first home should feel exciting, not overwhelming. We explain every step in plain English — from how much you can borrow and what deposit you really need, to agreements in principle, offers and completion day.",
    points: [
      "Deposits from as little as 5% across whole-of-market lenders",
      "Agreement in principle arranged quickly, so you can offer with confidence",
      "Help with schemes, gifted deposits and guarantor options",
      "One named advisor from your first call to collecting the keys",
    ],
  },
  {
    slug: "next-time-buyer",
    title: "Next-Time Buyer",
    tagline: "Selling and buying together? We plan the chain, the equity and the timing.",
    image: IMAGES.movingHome,
    description:
      "Moving up the ladder means juggling a sale, a purchase and a chain. We coordinate the finances so the timing works — releasing your equity wisely and keeping your monthly payments comfortable.",
    points: [
      "Porting vs. new deal — we compare keeping your current mortgage against switching",
      "Equity release from your sale planned into the new purchase",
      "Chain-friendly timelines agreed with lenders up front",
      "Protection reviewed so the bigger home stays protected",
    ],
  },
  {
    slug: "remortgage",
    title: "Remortgage",
    tagline: "Fix ending? We compare your lender's offer against the wider market and switch you if it pays.",
    image: IMAGES.hero,
    description:
      "When your fixed rate ends, loyalty rarely pays. We compare your existing lender's offer against the whole of the market — and if switching saves you money, we handle the paperwork from start to finish.",
    points: [
      "Whole-of-market comparison against your lender's retention offer",
      "Remortgage to raise capital for home improvements or consolidation",
      "Timing managed so you never drift onto a standard variable rate",
      "One honest fee, agreed in writing before any advice begins",
    ],
  },
  {
    slug: "buy-to-let",
    title: "Buy-to-Let",
    tagline: "First rental or growing portfolio — stress tests, SPVs and specialist lenders, handled.",
    image: IMAGES.buyToLet,
    description:
      "Whether it's your first rental or a growing portfolio, buy-to-let lending has its own rules. We navigate rental stress tests, limited company (SPV) structures and specialist lenders so your investment stacks up.",
    points: [
      "Rental stress tests explained and modelled before you commit",
      "Personal name vs. limited company (SPV) borrowing compared",
      "Portfolio landlords welcomed — specialist lenders on tap",
      "Insurance and protection for your rental income",
    ],
    disclaimer:
      "Most buy-to-let mortgages are not regulated by the Financial Conduct Authority. Some, known as consumer buy-to-let mortgages (where the property is or will be lived in by a family member), are regulated — we'll tell you which rules apply to your case before you commit.",
  },
  {
    slug: "protection",
    title: "Protection",
    tagline: "Life cover, critical illness and income protection that keeps the roof over your family.",
    image: IMAGES.protection,
    description:
      "A mortgage is only half the story. We make sure the roof stays over your family whatever life throws at you — with life cover, critical illness and income protection tailored to what you actually need, not what a comparison site pushes.",
    points: [
      "Life insurance sized to your mortgage and your family",
      "Critical illness cover that pays out when it matters",
      "Income protection so the bills are covered if you can't work",
      "Whole-of-market insurers — never tied to one provider",
    ],
  },
  {
    slug: "whole-of-life",
    title: "Whole of Life",
    tagline: "Permanent cover written into trust — built for estate planning and the April 2027 pension changes.",
    image: IMAGES.wholeOfLife,
    description:
      "Whole of Life insurance pays out whenever you die, not just during a fixed term. Written into trust, the pay-out lands outside your estate — so your family receives it quickly and without eating into what you leave behind. From 6 April 2027, unused pension pots will start counting towards inheritance tax for the first time; for many families this creates a new IHT bill the pension itself was never designed to settle. A Whole of Life policy, properly structured, is one of the cleanest ways to cover that liability — leaving the pension to do what you actually built it for.",
    points: [
      "Guaranteed pay-out whenever you die, with level or indexed cover",
      "Policy written into trust — proceeds sit outside your estate for IHT",
      "Covers the new inheritance tax liability on pensions from 6 April 2027",
      "Reviewable or guaranteed premium options to suit long-term budgets",
      "Reviewed every few years — because the right cover today isn't always the right cover in ten",
    ],
    checklist: {
      heading: "When Whole of Life makes sense",
      items: [
        "Your total estate — home, savings, investments and pension — is likely to exceed the inheritance tax nil-rate bands, especially once pensions join the estate in April 2027.",
        "You have a sizeable pension pot and want it passed on intact, rather than used to settle an IHT bill your family would otherwise have to find in cash.",
        "You're a business owner, landlord or shareholder leaving illiquid assets — company shares, buy-to-let property or land — and want a tax-free lump sum ready for the people inheriting them.",
      ],
    },
    disclaimer:
      "Trust and inheritance tax planning are not regulated by the Financial Conduct Authority. The information on this page is for general guidance only; please consult a qualified tax adviser or solicitor for advice on your personal estate planning. The value of policies written in trust and the tax treatment described here depend on your individual circumstances and may change in the future.",
  },
  {
    slug: "business-protection",
    title: "Business Protection",
    tagline: "Safeguard your business, its finances and the key people who keep it running.",
    image: IMAGES.business,
    description: BUSINESS_PROTECTION_INTRO,
    points: [
      "Key person insurance — protect the individuals your business relies on",
      "Shareholder & partnership protection to keep ownership stable",
      "Relevant life cover — tax-efficient protection for directors",
      "Business loan protection so debts don't outlive the business",
    ],
  },
];

export const WHY_BTK = [
  {
    title: "Whole-of-market access",
    text: "We search 90+ UK lenders. We're paid to find your best deal — never to push one lender's.",
  },
  {
    title: "One honest fee",
    text: "Typically £493 for a standard mortgage, agreed in writing before any advice begins. No surprises at completion.",
  },
  {
    title: "Properly regulated advice",
    text: "An Appointed Representative of PRIMIS Mortgage Network — fully qualified mortgage and protection advisers.",
  },
  {
    title: "A boutique, personal service",
    text: "One named advisor from first call to keys, with updates by phone, email or WhatsApp — your choice.",
  },
];

export const LENDERS = [
  "Nationwide",
  "Halifax",
  "Santander",
  "Barclays",
  "HSBC",
  "NatWest",
  "Coventry BS",
  "Skipton BS",
  "Virgin Money",
  "TSB",
  "Leeds BS",
  "Accord",
  "and 80+ more",
];

export const HOW_IT_WORKS = [
  {
    title: "Book a call",
    text: "Fifteen minutes, no obligation. We learn what you're trying to do and tell you honestly what's realistic.",
  },
  {
    title: "We search 90+ lenders",
    text: "You get a clear recommendation in plain English — the rate, the fees, the monthly cost, and why it suits you.",
  },
  {
    title: "We handle it to completion",
    text: "Application, paperwork, chasing the lender and the chain — until the keys are in your hand.",
  },
];

export const JARGON = [
  ["Agreement in Principle (AIP)", "A lender's early indication of how much they might lend you, based on a soft look at your finances. It lets you make offers with confidence — it isn't a guarantee, but it's close."],
  ["APRC", "Annual Percentage Rate of Charge. The total cost of your mortgage — interest plus fees — shown as a yearly percentage, so you can compare deals fairly."],
  ["Capital & interest (repayment)", "A mortgage where each monthly payment chips away at both the loan and the interest, so you own your home outright at the end of the term."],
  ["Conveyancing", "The legal work of transferring a property from seller to buyer — searches, contracts and the Land Registry — handled by a solicitor or licensed conveyancer."],
  ["Critical illness cover", "Insurance that pays you a tax-free lump sum if you're diagnosed with a serious illness named in the policy, so the mortgage still gets paid while you recover."],
  ["Deposit", "The chunk of the purchase price you pay up front from your own savings. The bigger the deposit, the better the rates you're usually offered."],
  ["Early Repayment Charge (ERC)", "A fee some lenders charge if you leave or overpay a deal before its initial period ends. Always worth knowing before you fix."],
  ["Equity", "The part of your home you actually own — its value minus what's left on your mortgage. It grows as you repay and as prices rise."],
  ["Exchange & completion", "Exchange is when contracts become legally binding and your deposit is paid. Completion is moving day — the money moves and you get the keys."],
  ["Fixed rate", "A mortgage where the interest rate — and your monthly payment — stays the same for a set period, usually two, three or five years."],
  ["Gazumping", "When a seller accepts a higher offer after already accepting yours. Painful, legal in England, and a good reason to move quickly to exchange."],
  ["Income protection", "Insurance that pays you a regular income if illness or injury stops you working, typically until you're back on your feet or the policy ends."],
  ["Interest-only", "A mortgage where your payments cover just the interest. The loan itself is repaid at the end from a plan you agree up front — common for buy-to-let."],
  ["Key person insurance", "Business protection that pays out if a person your business depends on dies or becomes critically ill, covering lost profit or recruitment costs."],
  ["Loan to Value (LTV)", "Your mortgage as a percentage of the property's value. A £340,000 loan on a £400,000 home is 85% LTV — lower LTVs unlock better rates."],
  ["Porting", "Taking your existing mortgage deal with you when you move home, instead of ending it early and paying charges."],
  ["Stamp Duty (SDLT)", "A tax on property purchases in England and Northern Ireland, charged in bands. First-time buyers get relief — try our stamp duty calculator."],
  ["Standard Variable Rate (SVR)", "The lender's default rate you drift onto when a deal ends. Almost always expensive — a reminder to remortgage before your fix finishes."],
  ["Tracker", "A mortgage whose rate follows the Bank of England base rate plus a set margin. Payments fall when the base rate falls — and rise when it rises."],
];

export const GUIDES = [
  {
    title: "The first-time buyer's roadmap",
    minutes: 4,
    summary: "From saving a deposit to collecting keys — the whole journey in order.",
    body: [
      "Start with the honest numbers: what you earn, what you spend, and what you've saved. Lenders typically offer around 4.5 times your income, and deposits start from 5% — but the stronger your deposit, the kinder the rate.",
      "Next, get an Agreement in Principle. It takes minutes, involves a soft credit check, and tells estate agents you're a serious buyer. Then the fun part: viewings, and an offer.",
      "Once your offer is accepted, we submit the full mortgage application, the lender values the property, and your solicitor handles the legal work. Exchange makes it binding; completion gets you the keys. From offer to keys typically takes 8–12 weeks — and we chase every party so you don't have to.",
    ],
  },
  {
    title: "Remortgaging: when and why to switch",
    minutes: 3,
    summary: "Your fix is ending. Here's how to avoid drifting onto an expensive rate.",
    body: [
      "When a fixed or tracker deal ends, your lender moves you onto their Standard Variable Rate — almost always their most expensive. Start looking three to six months before your deal ends; most offers can be held that long.",
      "Your existing lender will offer a 'product transfer'. Sometimes it's competitive; often it isn't. We compare it against 90+ lenders and switch you if it pays — many remortgages come with no legal fees and no valuation fee as part of the lender's incentive package.",
      "A remortgage can also raise money: for home improvements, consolidating expensive debts, or helping family onto the ladder. We'll tell you plainly whether it's worth it once fees are counted.",
      "Debt consolidation risk warning: Think carefully before securing other debts against your home. Consolidating debt may reduce your outgoings now, but you may end up paying more overall. Your home may be repossessed if you do not keep up repayments on your mortgage.",
    ],
  },
  {
    title: "Buy-to-let basics for new landlords",
    minutes: 4,
    summary: "Stress tests, deposits and SPVs — what actually matters before you invest.",
    body: [
      "Buy-to-let mortgages are assessed on the rent, not just your income. Lenders 'stress test' the rent against the payment at a higher notional rate — typically requiring the rent to cover 125–145% of it. We model this before you offer, so no surprises.",
      "Expect a deposit of around 25%, and remember the extra costs: the 5% stamp duty surcharge on additional properties, licensing in some areas, and safety certificates.",
      "Many landlords now buy through a limited company (SPV) for tax reasons. It isn't right for everyone — we'll walk you through the trade-offs and the specialist lenders who cater for both routes.",
    ],
  },
  {
    title: "Protecting the roof over your family",
    minutes: 3,
    summary: "Life cover, critical illness and income protection — which does what.",
    body: [
      "Life insurance pays out if you die — usually sized to clear the mortgage and leave your family secure. It's the cheapest of the three and the one most people should have from day one of ownership.",
      "Critical illness cover pays a lump sum on diagnosis of a serious condition named in the policy, while you're still here to benefit — covering treatment time off work, or clearing the mortgage entirely.",
      "Income protection is the quiet hero: a monthly income if illness or injury stops you working. Statutory sick pay won't cover a mortgage for long; this will. We'll help you blend the three so you're covered without overpaying.",
    ],
  },
];

export const BLOG_POSTS = [];

export const GOOGLE_REVIEWS_URL =
  "https://www.google.com/maps/place/BTK+Mortgage+Services+Ltd/data=!4m7!3m6!1s0x24b73811b16eccf3:0x892d05510ea1253c!8m2!3d47.73855!4d12.5088275!16s%2Fg%2F11y3_fblsx!19sChIJ88xusRE4tyQRPCWhDlEFLYk";
export const GOOGLE_RATING = "5.0";
export const GOOGLE_REVIEW_COUNT = "62";

export const REFER = {
  heading: "Know someone buying, moving or remortgaging?",
  intro:
    "Recommend BTK Mortgage Services to a friend, family member or colleague. When their mortgage completes, you'll receive a £100 John Lewis or Amazon voucher — our thank-you for spreading the word.",
  steps: [
    ["Tell us about them", "Fill in the short form below with your details and your friend's — it takes thirty seconds."],
    ["We look after them", "Ben gets in touch for a friendly, no-pressure chat and takes it from there."],
    ["You get thanked", "When their mortgage completes, a £100 John Lewis or Amazon voucher lands with you. Simple as that."],
  ],
};

export const HOW_IT_WORKS_PAGE = [
  {
    title: "Discovery Call",
    text: "A quick call or video chat, whichever suits you, so we can understand your situation and what you're hoping to achieve.",
  },
  {
    title: "Fact Find",
    text: "A focused 45–60 minute conversation to go through your circumstances in detail and start building your plan. Beforehand you'll get a simple checklist of the documents to have ready.",
  },
  {
    title: "Lender Research",
    text: "We go away and stress-test your case against 90+ lenders, then come back with illustrations for the right products — ready for your approval.",
  },
  {
    title: "Agreement in Principle",
    text: "A credit check with your chosen lender. Most now use a soft search that won't touch your credit file, and we'll always tell you which applies before going ahead. If you're buying, this is what estate agents need to see before accepting your offer.",
  },
  {
    title: "Offer Accepted",
    text: "Once your offer is accepted, we schedule a short call to go through the property details and start planning how to protect your payments if life ever gets in the way.",
    tag: "If you're buying",
  },
  {
    title: "Application Submitted",
    text: "With your offer accepted and protection taking shape, we submit your full mortgage application. You'll know exactly what happens next, and we'll help with surveys and buildings insurance along the way.",
    tag: "If you're buying",
  },
  {
    title: "Full Application",
    text: "On acceptance we move straight to submitting your full application — this is what reserves your rate with the lender — and you'll get confirmation of exactly what happens next.",
    tag: "If you're remortgaging",
  },
  {
    title: "Protection Review",
    text: "While your application progresses, we review your existing cover — or set new cover up if you have none — so your payments stay protected whatever happens.",
    tag: "If you're remortgaging",
  },
  {
    title: "Underwriting & Valuation",
    text: "The lender's underwriter assesses your case in full and completes their valuation of the property.",
  },
  {
    title: "Mortgage Offer",
    text: "Once everything's approved, you receive your formal mortgage offer from the lender.",
  },
  {
    title: "Completion",
    text: "The big day. Funds complete, keys are released (or your new rate begins) — and your mortgage is officially in place.",
  },
  {
    title: "We Don't Stop There",
    text: "Once you're a client, we're back in touch around six months before your deal ends — so you're never left to drift onto your lender's standard variable rate.",
  },
];

export const FEE_DISCLOSURE =
  "Typically we charge a mortgage fee of £493 for standard mortgages and re-mortgages but can charge up to 2% of the mortgage amount. The fee will be agreed up front before any advice is given, and is payable on application. We also receive commission from the mortgage lender. For protection products, we are paid by commission from the insurance provider — no fee is charged to you.";

export const RISK_WARNING =
  "Your home may be repossessed if you do not keep up repayments on your mortgage.";

export const CALC_RISK_WARNING =
  "This information is a guide only and should not be relied on as a recommendation or advice that any particular mortgage is suitable for you. All mortgages are subject to the applicant(s) meeting the eligibility criteria of the specific lender. You should make an appointment to receive mortgage advice which will be based on your needs and circumstances.";

export const DEBT_CONSOLIDATION_WARNING =
  "Think carefully before securing other debts against your home. Consolidating debt may reduce your outgoings now, but you may end up paying more overall. Your home may be repossessed if you do not keep up repayments on your mortgage.";

export const FCA_DISCLOSURE =
  "BTK Mortgage Services is a trading name of Kingston Mortgage Services Ltd, an Appointed Representative of PRIMIS Mortgage Network. PRIMIS Mortgage Network is a trading name of First Complete Ltd, which is authorised and regulated by the Financial Conduct Authority. Kingston Mortgage Services Ltd — Financial Conduct Authority Firm Reference Number 463852. You can verify these details on the Financial Conduct Authority register at register.fca.org.uk.";

export const COMPANY_DETAILS =
  "Ashley House, 136/138 The Broadway, Tolworth, Surrey, England, KT6 7JD. Company number 05628948. Registered in England and Wales.";

export const UK_REGIME_NOTE =
  "The guidance provided within this website is subject to the UK regulatory regime and is therefore primarily targeted at consumers based in the UK.";

export const LEGAL_UPDATED = "29 October 2026";

export const PRIVACY_SECTIONS = [
  {
    title: "Who we are",
    body: [
      "BTK Mortgage Services is the trading name of Kingston Mortgage Services Ltd ('we', 'us'), an Appointed Representative of PRIMIS Mortgage Network, based at Ashley House, 136/138 The Broadway, Tolworth, Surrey KT6 7JD (company number 05628948). We are the data controller for the personal information you give us through this website.",
    ],
  },
  {
    title: "What we collect",
    body: [
      "When you submit an enquiry, book a call or refer a friend we collect your name, email address, telephone number and the contents of your message. We also collect standard technical data such as your browser type and how you reached the site.",
    ],
  },
  {
    title: "How we use it",
    body: [
      "We use your details only to respond to your enquiry, arrange and prepare for your appointment, and provide the mortgage or protection advice you ask us for. We do not sell your data, and we do not send marketing emails without your consent.",
      "Where your enquiry proceeds to advice, your information may be shared with lenders and insurers strictly as needed to arrange the products you apply for.",
    ],
  },
  {
    title: "How long we keep it",
    body: [
      "Enquiry details that do not proceed to advice are deleted within 12 months. Where we provide regulated advice, records are retained as required by Financial Conduct Authority rules.",
    ],
  },
  {
    title: "Your rights",
    body: [
      "You can ask us at any time for a copy of the data we hold about you, for it to be corrected, or for it to be deleted where the law allows. Contact us at the email address shown on our contact page. You also have the right to complain to the Information Commissioner's Office (ICO).",
    ],
  },
];

export const COOKIE_SECTIONS = [
  {
    title: "What cookies we use",
    body: [
      "This website uses a small number of strictly necessary cookies required for the site to function (for example, remembering your booking selections during a session). We do not use advertising or cross-site tracking cookies.",
    ],
  },
  {
    title: "Analytics",
    body: [
      "If we enable privacy-respecting analytics, these collect aggregated, anonymous usage statistics only. You can block all cookies in your browser settings without affecting the core features of this site.",
    ],
  },
  {
    title: "Managing cookies",
    body: [
      "Most browsers let you refuse or delete cookies via their settings. Doing so will not prevent you from using the calculator, booking a call or sending an enquiry.",
    ],
  },
];

export const COMPLAINTS_SECTIONS = [
  {
    title: "About this procedure",
    body: [
      "Kingston Mortgage Services Ltd (trading as BTK Mortgage Services) are an Appointed Representative of PRIMIS Mortgage Network, a trading name of First Complete Ltd. First Complete Ltd is authorised and regulated by the Financial Conduct Authority.",
      "We are committed to providing a professional service to all our customers. If you are unhappy then we want to hear about it so we can try to put things right. With this in mind, we have the following complaints procedure in place.",
    ],
  },
  {
    title: "How to make a complaint",
    body: [
      "You can make a complaint by any reasonable means including telephone, letter or email.",
      "Our contact details: Write to — BTK Mortgage Services, c/o Kingston Mortgage Services Ltd, Ashley House, 136/138 The Broadway, Tolworth, Surrey KT6 7JD. Telephone — 01344 578847. Email — ben@btkmortgages.co.uk.",
      "If you prefer, you can also refer your complaint to PRIMIS directly using the following contact details: Write to — PRIMIS Mortgage Network, Customer Resolution Team, Ground Floor, Birmingham Business Park, B37 7YT. Telephone — 0121 767 1139. Email — complaints.solihull@primis.co.uk. You can also complain via their website: www.primis.co.uk/privacy-notices/complaints. The same section of the website contains more information about PRIMIS' role in complaints handling and about how Appointed Representative relationships work.",
    ],
  },
  {
    title: "Simplified complaints",
    body: [
      "We will use this process if your complaint is about a simple matter that we can look into and solve quickly and easily; and you direct it to us (rather than directly to PRIMIS Mortgage Network) in the first instance.",
      "We will investigate your complaint and aim to resolve it within three business days following the date of receipt. If you are happy to accept our proposed resolution, we will send you written confirmation of our investigation.",
      "If you cannot confirm acceptance by the end of the third working day (for example, because you are not happy with our proposed response or if you are not available to discuss it with us) then the case will be referred to PRIMIS Mortgage Network. It will then be handled in line with the Formal Complaint process outlined below.",
      "If your complaint is more complex or is unlikely to be resolved quickly then we will usually refer it to PRIMIS straight away.",
    ],
  },
  {
    title: "Formal complaints",
    body: [
      "The formal complaints process will be used where we can't resolve your complaint to your satisfaction within 3 working days; or your complaint is likely to involve more complex assessment or investigations; or you send your complaint directly to PRIMIS Mortgage Network rather than to us in the first instance; or you ask us to deal with your complaint in this way rather than via a simplified process.",
      "Upon receipt PRIMIS will acknowledge your complaint promptly and will investigate it fairly and impartially. They will write to you within 8 weeks to confirm the outcome of their investigation.",
      "In the unlikely event that their investigation is not complete within eight weeks of receipt of your complaint they will write to you to explain why and let you know when you can expect to hear from them. They will also provide details of how to contact the Financial Ombudsman Service if you are not satisfied with progress.",
    ],
  },
  {
    title: "The Financial Ombudsman Service",
    body: [
      "If, following PRIMIS' investigation you are still not happy with the outcome you have a statutory right to refer your complaint to the Financial Ombudsman Service. It is a service free of charge to consumers and you may refer the matter to the Financial Ombudsman Service (FOS) within six months from the date that you received a final response to your complaint.",
      "You can contact the service using the following details: Telephone — 0800 023 4567. Email — complaint.info@financial-ombudsman.org.uk. You can also visit their website and refer complaints to them online at www.financial-ombudsman.org.uk.",
    ],
  },
  {
    title: "Extra help or support",
    body: [
      "We are committed to providing a complaints service that is accessible to all our customers. If you will have any difficulties with any elements of the process that is outlined above, or if there are circumstances that might mean we need to change the way in which we handle your complaint, then please let us know when you tell us about your complaint.",
    ],
  },
];

export const REFERRAL_TERMS_SECTIONS = [
  {
    title: "The reward",
    body: [
      "When you refer someone to BTK Mortgage Services and their mortgage completes with us, you will receive a £100 voucher, your choice of John Lewis or Amazon, within 30 days of completion.",
    ],
  },
  {
    title: "Eligibility",
    body: [
      "The scheme is open to anyone aged 18 or over. The referred person must be a new client to BTK Mortgage Services, must mention (or be submitted via) the referral before their first appointment, and must complete a mortgage arranged by us.",
      "One reward is paid per completed mortgage. Where two people refer the same client, the first referral received counts.",
    ],
  },
  {
    title: "Consent",
    body: [
      "Please only share a friend's contact details with their knowledge and permission. We contact referred clients once, courteously, and never add them to marketing lists without consent.",
    ],
  },
  {
    title: "General",
    body: [
      "The reward has no cash alternative and cannot be combined with other referral promotions. We may amend or withdraw the scheme at any time, but any referral already registered will be honoured on its original terms.",
    ],
  },
];
